import React, { useContext } from 'react'
import { CircularProgress, makeStyles, Theme } from '@material-ui/core'
import AppContext from '../app/context'

export interface AppSpinnerProps {
  show?: boolean
  relative?: boolean
  height?: number | string
}

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: (props: { relative?: boolean; height?: number | string }) => {
    return {
      position: props.relative ? 'relative' : 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      background: 'rgba(#121212, 0.4)',
      zIndex: 9000,
      margin: props.relative ? `${theme.spacing(1.5)}px 0` : undefined,
      height: props.relative ? `${props.height || '100%'}` : '100%',
    }
  },

  positionContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-17px, -15px)',
  },
}))

const AppSpinner = ({ show, relative, height }: AppSpinnerProps) => {
  const { state } = useContext(AppContext)

  const styles = useStyles({ relative: relative, height: height })

  if (!show || !state.locationDesignConfig) return null

  return (
    <div className={styles.wrapper}>
      <div className={styles.positionContainer}>
        <CircularProgress
          size={30}
          style={{ color: state.locationDesignConfig.baseColors.primary }}
        />
      </div>
    </div>
  )
}

export default AppSpinner
